// SPA mode — single-origin, client-rendered PWA.
export const ssr = false;
export const prerender = true;
export const trailingSlash = 'always';
